// extracted by mini-css-extract-plugin
export default {"franceConnectLogo":"welcome_franceConnectLogo__EtyxW","continueButton":"welcome_continueButton__jXjtU"};